import { useMemo } from "react";

import type { TranslatableNameWithType } from "app/pages/sales-intelligence/sub-modules/signals/models/services/FilterNamingService";
import type { SignalFilterDropdownLabelModel } from "app/pages/sales-intelligence/sub-modules/signals/models/view/SignalFilterDropdownLabelModel";
import {
    buildSignalFilterDropdownLabel,
    type BuildSignalFilterDropdownLabelParams,
} from "app/pages/sales-intelligence/sub-modules/signals/utils/buildSignalFilterDropdownLabel";

export type SignalFilterDropdownLabelState = {
    model: SignalFilterDropdownLabelModel;
    filterName: Readonly<TranslatableNameWithType>;
};

const useSignalFilterDropdownLabel = (params: BuildSignalFilterDropdownLabelParams): SignalFilterDropdownLabelState => {
    const { buildName, resolvePrimaryLabel } = params;

    return useMemo(() => {
        const filterName = buildName();

        return {
            filterName,
            model: buildSignalFilterDropdownLabel({
                buildName: () => filterName,
                resolvePrimaryLabel,
            }),
        };
    }, [buildName, resolvePrimaryLabel]);
};

export default useSignalFilterDropdownLabel;
